// Auth helpers — last logged-in username drives the WebAuthn endpoints
// (available/login-options): with it the backend scopes to that user's
// credentials, without it only discoverable passkeys work.

// Laravel identifies a user by `email`; `username` is the old Node shape (review 25-10-2026).
export function rememberUsername(user) {
  const naam = user?.email || user?.username;
  if (naam) localStorage.setItem('last_username', naam);
}

export function lastUsernameQuery() {
  const u = localStorage.getItem('last_username');
  return u ? `?username=${encodeURIComponent(u)}` : '';
}

// The device token lives under `device_token`; `token` is the old key. A start-up check that
// failed once removed only `device_token`, so the app stayed logged in on `token` while the QR
// scanner sent "Bearer null" -> 401 (25-10-2026). Read it here, never from localStorage directly.
export function getDeviceToken() {
  return localStorage.getItem('device_token') || localStorage.getItem('token');
}
